import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./Header";
import Menu from "./Menu";
import VisaoGeral from "./VisaoGeral";
import Modulos from "./Modulos";
import Matriz from "./Matriz";
import ContextProvider from "./ContextProvider";

class CursoLayout extends Component {
    render() {
        return (
            <>
                <ContextProvider>
                    <Header />
                    <Menu />
                    <Switch>
                        <Route path="/:entidade/curso/:curso/:cursoid/curso-visao-geral" component={VisaoGeral} />
                        <Route path="/:entidade/curso/:curso/:cursoid/curso-modulos" component={Modulos} />
                        <Route path="/:entidade/curso/:curso/:cursoid/curso-cursos" component={Matriz} />
                    </Switch>
                </ContextProvider>
            </>
        );
    }
}

export default CursoLayout;
